import React from 'react';
import {
    TextInput,
    DateInput,
    SimpleForm,
    Edit,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import ErrorBoundary from '../../ErrorBoundary';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export const styles = {

     inlineBlock: {
         display: 'inline-flex', 
         marginRight: '1rem' 
     },
     inlineBlockLeft: {
         display: 'inline-flex',
         float:    'left', 
         marginRight: '1rem' 
     },
     hidden : {
         display: 'none' 
     },
     inputStyle : {
         width :'20px',
     },
     controlInputStyle : {
        width :'70px',
        fontSize: '8'
    },
     labelStyle : {
        width :'40px',
        backgroundColor: 'silver'
    },
    iniLabelStyle : {
        width :'20px',
        backgroundColor: 'silver'
    },
    dateStyle : {
        width: '120px',
        
    },
    tableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'1px solid  black', 
        width: "100%"
    },
    h3: {
        textAlign: 'center',
        width: '100%'
    },
    clearTableStyle :{ 
        margin: 'auto',  
        fontSize:'12px', 
        fontWeight:'bold', 
        cellspacing:"3", 
        border:'0px solid  black', 
        width: "100%"
    },
    inlineBlock: {
        display: 'inline-flex',
        margin: '5px',
        padding: '5px',
    },

 };
 
 const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};
const UserEditActions = ({ basePath}) => (
    <CardActions style={cardActionStyle}>
    <ListButton basePath={'/val_REFRA_METR_o?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'} />
</CardActions>
);

const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect={'/val_REFRA_METR_o?filter=%7B"ins_id"%3A"' + ins_id +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const IsPass = [
    {
        id: 'P',
        name: 'Pass'
    },
    {
        id: 'F',
        name: 'Fail'
    }
]

const GetInsID = ({record})=> (
    ins_id  = (record && record.ins_id)? record.ins_id:ins_id
)

const InstEdit = ({classes, ...props }) => (
<ErrorBoundary>  
    <Edit actions={<UserEditActions />}   {...props}  title="Edit">
        <SimpleForm toolbar={<UserCreateToolbar />} >
        <GetInsID props ={props} />
        <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>REFRACTOMETER</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center'  label='' defaultValue={loc} /></td>
                        <td>Instrument Serial Number:</td><td><TextInput source='serial_num' label = '' />
                            <TextInput className={classes.hidden} source='ins_id' label='' defaultValue={(props && props.location)?( (props.location.ins_id)?props.location.ins_id:ins_id):ins_id} /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <p><b><u>Installation Qualification (IQ):</u></b></p>
                        Set up Reichert TS Meter-DSP per User’s Guide
                        <p><b><u>Operational Qualification:</u></b></p>
                         Room Temperature Thermometer
                        <p><b>Criteria:  Must be within acceptable temperature range, room temperature (10◦C to 45◦C).  Attach NIST certificate with of thermometer used during validation.</b></p>
                        </td>
                    </tr>
                    <tr>
                        <td>Serial Number:</td><td><TextInput source="sub_serial_num" label=""   /></td>
                        <td>MIN Temperature:</td><td><TextInput source="min_temp" label=""   /></td>
                    </tr>
                    <tr>
                        <td>Actual Temperature:</td><td><TextInput source="act_temp" label=""   /></td>
                        <td>MAX Temperature:</td><td><TextInput source="max_temp" label=""   /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <b><u>Quality Control Test</u></b>
                        <p><b>Criteria:  New vials must be opened the day the Operational Qualification is performed, SOP 09.25, 
                            REFRACTOMETER DAILY CALIBRATION and manufacturer’s instructions must be followed.  
                            Manufacture’s expiration date must be used and the manufacture’s assay sheet attached</b></p>
                           
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Assure H2O reading is within +/-0.1 g/100 ml at room temperature (10◦C to 45◦C).<BooleanInput source="is_h2o" label = '' /></td>
                        <td>Initial:<TextInput source="h2o_init" label=""   /></td>
                        <td>Date:<DateInput source="h2o_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Low Control Lot Number:</td><td><TextInput source="low_con" label=""   /></td>
                        <td>Low Control Expiration Date:</td><td><DateInput source="low_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Normal Control Lot Number:</td><td><TextInput source="nor_con" label=""   /></td>
                        <td>Normal Control Expiration Date:</td><td><DateInput source="nor_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>High Control Lot Number:</td><td><TextInput source="high_con" label=""   /></td>
                        <td>High Control Expiration Date:</td><td><DateInput source="high_con_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Low Control Result:</td><td><TextInput source="low_con_rst" label=""   /></td>
                        <td>Normal Control Result:</td><td><TextInput source="nor_con_rst" label=""   /></td>
                    </tr>
                    <tr>
                        <td>High Control Result:</td><td><TextInput source="high_con_rst" label=""   /></td>
                        <td colSpan={2}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Low Control Result within acceptable manufacturer’s ranges?<BooleanInput source='is_low_con_acpt' label='' /></td>
                        <td>Initial: <TextInput source='low_con_acpt_init' label='' /></td>
                        <td>Date: <DateInput source='low_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Normal Control Result within acceptable manufacturer’s ranges?<BooleanInput source='is_nor_con_acpt' label='' /></td>
                        <td>Initial: <TextInput source='nor_con_acpt_init' label='' /></td>
                        <td>Date: <DateInput source='nor_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>High Control Result within acceptable manufacturer’s ranges?<BooleanInput source='is_high_con_acpt' label='' /></td>
                        <td>Initial: <TextInput source='high_con_acpt_init' label='' /></td>
                        <td>Date: <DateInput source='high_con_acpt_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <p><b><u>Performance Qualification:</u></b></p>
                        <b>Criteria:  Must be within manufacturer’s assay sheet specifications (attached) and within .2 values of each other 
                            for each level of control being tested.  
                            Three different trained employees must perform the quality control at each level 3 different times.</b>
                        </td>
                    </tr>
                    <tr>
                        <td>Low Control Lot Number:</td><td><TextInput source="low_con_p" label=""   /></td>
                        <td>Low Control Expiration Date:</td><td><DateInput source="low_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Normal Control Lot Number:</td><td><TextInput source="nor_con_p" label=""   /></td>
                        <td>Normal Control Expiration Date:</td><td><DateInput source="nor_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>High Control Lot Number:</td><td><TextInput source="high_con_p" label=""   /></td>
                        <td>High Control Expiration Date:</td><td><DateInput source="high_con_p_dt" label=""   locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td>Entered By Initial: <TextInput source='enterd_by_init' label='' /></td>
                        <td>Date: <DateInput source='enterd_by_dt' label=''  locales='en-us' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>
                        <ArrayInput source="readings" label="Performance Readings">
                            <SimpleFormIterator disableReordering>
                                <TextInput source="low_con" label="Low Contorl" formClassName={classes.inlineBlock} />
                                <TextInput source='low_init' label="Initial" formClassName={classes.inlineBlock} />
                                <DateInput source="low_dt" label="Date"   locales='en-us' formClassName={classes.inlineBlock} />
                                <TextInput source="nor_con" label="Normal Contorl" formClassName={classes.inlineBlock} />
                                <TextInput source='nor_init' label="Initial" formClassName={classes.inlineBlock} />
                                <DateInput source="nor_dt" label="Date"   locales='en-us' formClassName={classes.inlineBlock} />
                                <TextInput source="high_con" label="High Contorl" formClassName={classes.inlineBlock} />
                                <TextInput source='high_init' label="Initial" formClassName={classes.inlineBlock} />
                                <DateInput source="high_dt" label="Date"   locales='en-us' formClassName={classes.inlineBlock} />
                            </SimpleFormIterator>
                        </ArrayInput>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4}>All low level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanInput source='is_low_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>All normal level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanInput source='is_nor_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}>All high level results were within the manufacturer’s assay sheet requirements and within .2 values of each other
                        <BooleanInput source='is_high_rst'  label='' /></td>
                    </tr>
                    <tr>
                        <td>Results Evaluated By Initial</td><td><TextInput source='eval_init' label=''/></td>
                        <td>Date</td><td><DateInput source='eval_dt' label=''  locales='en-us'  /></td>
                    </tr>
                    <tr>
                        <td colSpan={4}><b>Summary:</b></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Equipment meets validation criteria and manufacturer’s specifications and is acceptable for use
                        <BooleanInput source='is_equip_val'  label='' /></td>
                        <td>Inital<TextInput source='equip_val_init'  label=''/></td>
                        <td>Date<DateInput source='equip_val_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <tr>
                        <td colSpan={2}>Equipment DOES NOT meet validation criteria and manufacturer’s specifications and is NOT acceptable for use
                        <BooleanInput source='is_equip_not_val'  label='' /></td>
                        <td>Inital<TextInput source='equip_not_val_init'  label=''/></td>
                        <td>Date<DateInput source='equip_val_not_dt'  locales='en-us'  label=''/></td>
                    </tr>
                    <FormDataConsumer>
                    {({
                        formData, // The whole form data
                        scopedFormData, // The data for this item of the ArrayInput
                        getSource, // A function to get the valid source inside an ArrayInput
                        ...rest
                    }) =>
                        ( role==='Admin' || level > 7 )? (
                    <tr>
                        <td  colSpan={4}>
                            <table  className={classes.tableStyle} >
                            <tr>
                                <td>Center Manager:</td><td><TextInput source='mgr_name' label='Name' /></td>
                                <td>Initial</td><td><TextInput source='mgr_sign' label='' /></td>
                                <td>Date</td><td><DateInput source='mgr_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Quality Assurance:</td><td><TextInput source='qa_name' label='Name' /></td>
                                <td>Initial</td><td><TextInput source='qa_sign' label='' /></td>
                                <td>Date</td><td><DateInput source='qa_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Laboratory Director:</td><td><TextInput source='dir_name' label='Name' /></td>
                                <td>Initial</td><td><TextInput source='dir_sign' label='' /></td>
                                <td>Date</td><td><DateInput source='dir_dt' label='' /></td>
                            </tr>
                            <tr>
                                <td>Corporate Quality:</td><td><TextInput source='cop_qa_name' label='Name' /></td>
                                <td>Initial</td><td><TextInput source='cop_qa_sign' label='' /></td>
                                <td>Date</td><td><DateInput source='cop_qa_dt' label='' /></td>
                            </tr>
                            </table>
                        </td>
                    </tr>
                     ) : ( role==='QA' || level > 6 )? (
                        <tr>
                            <td  colSpan={4}>
                            <table  className={classes.tableStyle} >
                            <tr>
                                <td>Quality Assurance</td><td><TextInput source='qa_name' label='Name' /></td>
                                <td>Initial</td><td><TextInput source='qa_sign' label='' /></td>
                                <td>Date</td><td><DateInput source='qa_dt' label='' /></td>
                            </tr>
                            </table>
                        </td>
                        </tr>
                         ) :  <></>
                    }
                    </FormDataConsumer>

                </tbody>
            </table>
        </SimpleForm>        
    </Edit>
    </ErrorBoundary>  
);

export default withStyles(styles) (InstEdit);
